/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListModule
 * Purpose		: Module for CurrentProductList.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { CurrentProductListService } from './CurrentProductList.service';
import { CurrentProductListListComponent } from './CurrentProductListList.component';
import { CurrentProductListSearchComponent } from './CurrentProductListSearch.component';
import { CurrentProductListDetailsComponent } from './CurrentProductListDetails.component';

import { CurrentProductListRoutingModule } from './CurrentProductList-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    CurrentProductListRoutingModule
  ],
  declarations: [
    CurrentProductListListComponent,
	CurrentProductListSearchComponent,
	CurrentProductListDetailsComponent
  ],
  providers: [
    CurrentProductListService
  ]
})

export class CurrentProductListModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CurrentProductList/CurrentProductList.module.ts